<template>
  <!-- 新闻资讯 -->
  <div class="news">
    <div class="contain">
      <!-- <Mainpage></Mainpage> -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Mainpage from "@/views/news/components/mainpage.vue";
export default {
  name: "News",
  components: {
    Mainpage,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.news {
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 1px solid red;

  .contain {
    // border: 1px solid red;
    // height: 1300px;
    // width: calc(100% - 120px);
    width: 1200px;
  }
}
</style>
